import React from "react";
import useHoverTooltip from "./useHoverTooltip";
import "./EllipsisText.css";

/** Shows a tooltip while its content is hovered, including a disabled button, which gets no hover of its own. */
export default function HoverTooltip({text, children}) {
    const {show, hide, tooltip} = useHoverTooltip(text);
    if (!text) {
        return children;
    }
    // A disabled button cannot take focus, so the hint doubles as its accessible name.
    const labelProp = typeof children?.type === "string" ? "aria-label" : "ariaLabel";
    const content = React.isValidElement(children) && children.props[labelProp] === undefined
        ? React.cloneElement(children, {[labelProp]: text})
        : children;

    return (
        <>
            <span className="hoverTooltipTarget" onMouseEnter={show} onMouseLeave={hide}>
                {content}
            </span>
            {tooltip}
        </>
    );
}
